module.exports = __webpack_public_path__ + "static/binder3-a7cd016a23304241b7ca0334e62e3a70.png";